import React from "react";

function EfficiencyMonitor(props) {
    return (
        <div className="card" style={{ height: "400px" }}>
            <div
                className="card-header ui-sortable-handle"
                style={{ cursor: "move" }}
            >
                <h3 className="card-title">
                    <i className="fas fa-clipboard mr-1" />
                    Live Production Monitor
                </h3>
                <div className="card-tools">
                    <ul className="nav nav-pills ml-auto">
                        <li className="nav-item">
                            <a
                                className="nav-link active"
                                href="#revenue-chart"
                                data-toggle="tab"
                            >
                                Running Shift
                            </a>
                        </li>
                        <li className="nav-item">
                            <a
                                className="nav-link"
                                href="#sales-chart"
                                data-toggle="tab"
                            >
                                Last Completed Shift
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
            <div className="card-body">
                <div className="tab-content p-0">
                    <div
                        className="chart tab-pane active"
                        id="revenue-chart"
                        style={{ position: "relative", height: 300 }}
                    >
                        <div className="chartjs-size-monitor">
                            <div className="chartjs-size-monitor-expand"></div>
                            <div className="chartjs-size-monitor-shrink"></div>
                        </div>
                        <div className="chartjs-size-monitor">
                            <div className="chartjs-size-monitor-expand">
                                <div />
                            </div>
                            <div className="chartjs-size-monitor-shrink">
                                <div />
                            </div>
                        </div>
                        <canvas
                            id="revenue-chart-canvas"
                            height={600}
                            width={1242}
                            className="chartjs-render-monitor"
                            style={{
                                height: 300,
                                display: "block",
                                width: 621,
                            }}
                        />
                    </div>
                    <div
                        className="chart tab-pane"
                        id="sales-chart"
                        style={{ position: "relative", height: 300 }}
                    >
                        <canvas
                            id="sales-chart-canvas"
                            height={0}
                            width={0}
                            className="chartjs-render-monitor"
                            style={{ height: 0, display: "block", width: 0 }}
                        />
                    </div>
                </div>
            </div>
        </div>
    );
}

export default EfficiencyMonitor;
